import { useState } from "react"

export const useBranchFormHandling = () => {

    const [formData,setFormData] = useState({

        name: "",
        code: "",
        bankId: "",
        countryId: "",
        stateId: "",
        districtId: "",
        cityId: "",
        pinCodeId: "",
        addressLine1: "",
        addressLine2: "",
        landmark: "",
        active: true,


        nameStatus: "unchecked",
        codeStatus: "unchecked",
        bankIdStatus: "unchecked",
        countryIdStatus: "unchecked",
        stateIdStatus: "unchecked",
        districtIdStatus: "unchecked",
        cityIdStatus: "unchecked",
        pinCodeIdStatus: "unchecked",
        addressLine1Status: "unchecked",
        addressLine2Status: "unchecked",

    });    

    const [contacts, setContacts] = useState([
        {
        id: "",
        contactType: "",
        value: "",
        primary: false,
        isActive: true,

        contactTypeStatus: "unchecked",
        valueStatus: "unchecked",
        }
    ]);
    
    //Handle Change Function
    const handleChange = (event, selectEvent) => {
        let formState ={...formData};

        if(event && event.target){
            switch(event.target.name){
                case "name": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,80})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "code": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,30})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "addressLine1": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{5,60})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "addressLine2": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{0,60})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "landmark": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{0,40})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "value": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,80})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        else if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "countryId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";

                    formState.stateId = "";
                    formState.stateIdStatus = "unchecked";
                    
                    formState.districtId = "";
                    formState.districtIdStatus = "unchecked";

                    formState.cityId = "";
                    formState.cityIdStatus = "unchecked";

                    formState.pinCodeId = "";
                    formState.pinCodeIdStatus = "unchecked";

                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "stateId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";

                    formState.districtId = "";
                    formState.districtIdStatus = "unchecked";

                    formState.cityId = "";
                    formState.cityIdStatus = "unchecked";

                    formState.pinCodeId = "";
                    formState.pinCodeIdStatus = "unchecked";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "districtId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";

                    formState.cityId = "";
                    formState.cityIdStatus = "unchecked";

                    formState.pinCodeId = "";
                    formState.pinCodeIdStatus = "unchecked";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "cityId": {
                    const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";

                    formState.pinCodeId = "";
                    formState.pinCodeIdStatus = "unchecked";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                
                case "pinCodeId":{
                     const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,50})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        setFormData(formState);
    
    }

    //contacts handle change
    const handleContactChange = (index, event, selectEvent) => {
        setContacts((prev) => {
        const updatedContacts = [...prev];
        const contact = { ...updatedContacts[index] };

        if (event?.target) {
            const { name, value } = event.target;

            switch (name) {
            case "value": {
                const regex = /^([\s\S]{1,80})$/;

                contact.valueStatus =
                value === ""
                    ? "unchecked"
                    : regex.test(value.trim())
                    ? "success"
                    : "error";
                break;
            }

            case "isActive": {
                break;
            }
            case "primary": {
                break;
            }

            default: {
                contact[`${name}Status`] =
                value === "" ? "unchecked" : "success";
            }
            }

            contact[name] = value;
        }

        // 🔹 SELECT fields (MaterialSelect)
        else if (selectEvent) {
            const { name } = selectEvent;

            contact[`${name}Status`] =
            event ? "success" : "unchecked";

            contact[name] = event;
        }

        updatedContacts[index] = contact;
        return updatedContacts;
        });
    };


    //Submit Validation
    const checkAllFields = () => {
        let allowSubmit = false;
        const contactExists = Array.isArray(contacts) && contacts.length > 0
        const contactValidation = contactExists && contacts.every((item) => item?.contactTypeStatus === "success" && item?.valueStatus === "success" )
        if (
        formData.nameStatus === "success" &&
        formData.codeStatus === "success" &&
        formData.bankIdStatus === "success" &&
        formData.countryIdStatus === "success" &&
        formData.stateIdStatus === "success" &&
        formData.districtIdStatus === "success" &&
        formData.cityIdStatus === "success" &&
        formData.pinCodeIdStatus === "success" &&
        formData.addressLine1Status === "success" &&
        contactValidation
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        contacts,
        setContacts,
        handleChange,
        handleContactChange,
        checkAllFields
    }
}